<div
  *ngrxLet="
    projectFacde.getTransportScenarioManudalLocationList$ as getTransportScenarioManudalLocationList
  "
  class="modal-content"
  piqetAngularDraggable
>
  <div class="organization-modal">
    <div>
      <span class="bootstrap-dialog-title header-title">{{ modalLabel }}</span>
      <button type="button" aria-label="Close" class="closeModal pull-right" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>

    <div class="modal-body body-modal" id="retailModal">
      <form [formGroup]="eolPreRetrailForm" [ngClass]="{ 'disabled-popup': !showEdit }">
        <div class="row" formGroupName="reuseProcessDetailForm">
          <div class="col-12">
            <label class="subTitleName">Select reusable component(s)</label>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div
                class="form-group required"
                aria-required="true"
                *ngrxLet="projectFacde.getComponentPreRetailList$ as getComponentPreRetailList"
              >
                <label
                  *ngIf="reuseProcessDetailForm.controls['reuseType']?.value"
                  class="sub-header-drpdown pb-2"
                  >Type</label
                >
                <ng-select
                  [clearable]="false"
                  [clearOnBackspace]="false"
                  #reuseTypefilter
                  [items]="reuseTypeList"
                  [searchable]="false"
                  formControlName="reuseType"
                  bindLabel="name"
                  [searchFn]="commonInputSearchForCountry"
                  (change)="getComponentListData($event)"
                  placeholder="Type *"
                  [readonly]="getComponentPreRetailList.length"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control search-input search"
                        id="inputValidation"
                        (input)="reuseTypefilter.filter($any($event.target).value)"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                      {{ item?.name }}
                    </div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    (componentSubmitted || submitted) &&
                    reuseProcessDetailForm.controls['reuseType']?.invalid
                  "
                  class="input-error"
                >
                  Type is required.
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group required" aria-required="true">
                <label
                  *ngIf="reuseProcessDetailForm.controls['componentName']?.value"
                  class="sub-header-drpdown pb-2"
                  >Selected component reused</label
                >
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #component
                  [multiple]="true"
                  [items]="componenetListItems"
                  [searchable]="false"
                  formControlName="componentName"
                  bindLabel="description"
                  [searchFn]="commonInputSearch"
                  [readonly]="isComponentDetailEdit"
                  placeholder="Select component reused *"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control search-input search"
                        id="inputValidation"
                        (input)="component.filter($any($event.target).value)"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div
                      [ngOptionHighlight]="search"
                      [class.disabled]="item.disabled"
                      title="{{ item?.description }}"
                    >
                      {{ item.description }}
                    </div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    (componentSubmitted || submitted) &&
                    reuseProcessDetailForm.controls['componentName']?.invalid
                  "
                  class="input-error"
                >
                  Component is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row my-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 customTruckCheckBox">
              <div class="d-flex checkBoxAlienMent">
                <div>
                  <input
                    type="checkbox"
                    [(ngModel)]="isReuseCheck"
                    [ngModelOptions]="{ standalone: true }"
                    class="chkOverview"
                    (change)="getValueOfcheckbox($event, 'reuse')"
                  />
                </div>
                <div>
                  <span class="checkbox-style">Reuse (%)</span>
                </div>
              </div>
              <div class="d-flex checkBoxAlienMent">
                <div>
                  <input
                    type="checkbox"
                    [(ngModel)]="isTripCheck"
                    [ngModelOptions]="{ standalone: true }"
                    class="chkOverview"
                    (change)="getValueOfcheckbox($event, 'trip')"
                  />
                </div>
                <div>
                  <span class="checkbox-style">No. of trips</span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <div class="row">
            <div class="col-md-6" *ngIf="isTripCheck || isReuseCheck">
              <piqet-angular-common-input
                formControlName="amount"
                [control]="reuseProcessDetailForm.get('amount')"
                label="Amount (per reuse cycle)"
                placeholder="Amount (per reuse cycle)"
                inputType="number"
                [minValue]="0"
                [maxValue]="isReuseCheck ? 100 : isTripCheck ? 9999 : 0"
                [preventNegative]="true"
                [enableRangeValidation]="true"
                [submitted]="componentSubmitted"
                (customBlur)="onAmountBlur($event)"
                [errorMessages]="{
                  nonNegative: 'Please enter a positive value',
                  min: 'Please enter a positive value',
                  max: isReuseCheck
                    ? 'Percentage of reuse can\'t be greater than 100%'
                    : isTripCheck
                    ? 'Number of trips can\'t exceed 9999'
                    : 'Value is too large'
                }"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>

        <hr [ngClass]="isTripCheck || isReuseCheck ? 'my-4' : 'my-2'" />

        <div class="row" formGroupName="transportationDetailForm">
          <div class="col-12">
            <label class="subTitleName">Add transport to filler</label>
          </div>
          <div>
            <ul class="nav nav-pills nav-justified buttonTab" id="myTab" role="tablist">
              <li
                class="nav-item mainLiTag"
                role="presentation"
                (click)="manualLocation(data)"
                *ngFor="let data of wholeData"
              >
                <button
                  id="location-tab"
                  [ngClass]="
                    selectedBox.id === data.transportaionId &&
                    (selectLocation || selectDistance || selectCustom)
                      ? 'nav-link active'
                      : 'nav-link'
                  "
                  type="button"
                >
                  <div class="image">
                    <img
                      [src]="data.img"
                      [height]="data.heightImg"
                      [width]="data.widthImg"
                      alt=""
                    />
                  </div>
                  <div class="displayName">
                    <span
                      [ngClass]="
                        selectedBox.id === data.transportaionId &&
                        (selectLocation || selectDistance || selectCustom)
                          ? 'active'
                          : ''
                      "
                      >{{ data.displayName }}</span
                    >
                  </div>
                </button>
              </li>
            </ul>
          </div>

          <div class="tab-content mt-3 mb-3">
            <!-- Location -->
            <div class="fade show" *ngIf="selectLocation">
              <div class="row my-2">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 customTruckCheckBox">
                  <div
                    class="d-flex checkBoxAlienMent"
                    *ngIf="getTransportScenarioManudalLocationList.length > 0"
                  >
                    <div>
                      <input
                        type="checkbox"
                        class="chkOverview"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="isCustomTruck"
                        (change)="chnageCustomTruck($event)"
                      />
                    </div>
                    <div>
                      <span class="checkbox-style">Custom truck</span>
                    </div>
                  </div>
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input type="checkbox" class="chkOverview" (change)="showPorts($event)" />
                    </div>
                    <div>
                      <span class="checkbox-style">Show only ports</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div
                    class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                  >
                    <div></div>
                    <div *ngIf="isCustomTruck && showCustomTruckAccess">
                      <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                        ><span class="redirectLinkText">Add custom truck</span></a
                      >
                      <a
                        class="setLinkIconPosition"
                        target="_blank"
                        replaceUrl="true"
                        routerLink="custom/customTrucks"
                      >
                        <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                      </a>
                      <span class="setLinkIconPosition" (click)="getCustomTruckList()"
                        ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label
                  *ngIf="!!isValidPort && getTransportScenarioManudalLocationList.length > 0"
                  class="input-error ms-4 port-err"
                  >{{ isValidPort }}</label
                >
              </div>
              <ng-container *ngrxLet="projectFacde.distanceErrorProject$ as distanceErrorProject">
                <div class="mt-3" *ngIf="distanceErrorProject != ''">
                  <span class="input-error-distance">{{ distanceErrorProject }}</span>
                </div>
              </ng-container>
              <div>
                <ng-container *ngIf="getTransportScenarioManudalLocationList?.length">
                  <piqet-angular-portlet
                    [columnDefs]="locationProcessDef"
                    [frameworkComponents]="frameworkComponents"
                    [gridData]="getTransportScenarioManudalLocationList"
                    [hideSearch]="true"
                    [hidePagination]="true"
                    [isSetWidth]="true"
                    [gridName]="'eol pre retail manual location'"
                    (inlineDataEditEvent)="inlineDataEditEvent($event)"
                  >
                  </piqet-angular-portlet>
                </ng-container>
              </div>
              <ng-template #other_content>
                <div class="row" *ngIf="getTransportScenarioManudalLocationList?.length == 0">
                  <div class="col-6">
                    <div class="d-flex justify-content-end align-items-end">
                      <p class="highlights" placeholder="Origin">
                        Select locations with "(Port)" for shipping
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group required">
                      <div class="ng-autocomplete autocomplete">
                        <ng-autocomplete
                          [data]="selectedCities"
                          #autoForOrigin
                          (inputCleared)="onClearSearch($event)"
                          [isLoading]="isLoading"
                          class="supplierdrpdown"
                          [searchKeyword]="keyword"
                          (inputChanged)="onSearch($event)"
                          historyIdentifier="selectedCities"
                          (selected)="selectEvent($event)"
                          [itemTemplate]="itemTemplate"
                          (keydown)="onKeyDownEvent($event)"
                          placeholder="Origin"
                          [notFoundTemplate]="notFoundTemplate"
                          formControlName="Origin"
                          (scrolledToEnd)="onScroll()"
                          [(ngModel)]="keywordAuto"
                        >
                        </ng-autocomplete>
                        <ng-template #itemTemplate let-item>
                          <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                        </ng-template>

                        <ng-template #notFoundTemplate let-notFound>
                          <div [innerHTML]="notFound"></div>
                        </ng-template>
                      </div>
                    </div>
                    <div
                      *ngIf="
                        setOriginsubmitted &&
                        !this.transportationDetailForm.controls['Origin']?.value?.hasOwnProperty(
                          'name'
                        )
                      "
                      class="input-error"
                    >
                      Select city from list.
                    </div>
                  </div>
                  <div class="col-sm-1 aligniconQuestion">
                    <span
                      placement="auto"
                      tooltipClass="sku-tooltip"
                      ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                    >
                      <a class="info-icon">
                        <span>
                          <img src="./assets/icons/question-mark-icon.svg" width="14" height="14"
                        /></span>
                      </a>
                    </span>
                  </div>
                  <div class="col-md-5">
                    <div>
                      <button
                        class="modelBtn setOriginBtn pull-right"
                        *ngIf="!isCheckUpdateOrigin"
                        (click)="setOrigin()"
                      >
                        Set origin
                      </button>
                      <button
                        class="modelBtn setOriginBtn pull-right"
                        *ngIf="isCheckUpdateOrigin"
                        (click)="setOrigin()"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </ng-template>
              <div
                *ngIf="
                  getTransportScenarioManudalLocationList?.length > 0 && !checkIsOrginBtn;
                  else other_content
                "
                class="row"
              >
                <div class="row mt-4">
                  <div class="col-4 d-flex justify-content-end ms-2">
                    <p
                      class="highlights"
                      [ngClass]="
                        transportationDetailForm.controls['transportModeForLocation'].value
                          ? 'custom-text-position'
                          : ''
                      "
                      placeholder="Origin"
                    >
                      Select locations with "(Port)" for shipping
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div>
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForLocation']?.value"
                      class="placeholder-sub-header pb-2"
                      >Holder_text</label
                    >
                    <ng-autocomplete
                      [data]="selectedCities"
                      #autoForDestination
                      (inputCleared)="onClearSearch($event)"
                      [isLoading]="isLoading"
                      class="supplierdrpdown"
                      [searchKeyword]="keyword"
                      historyIdentifier="selectedCities"
                      [itemTemplate]="itemTemplate"
                      (selected)="selectEvent($event)"
                      [notFoundTemplate]="notFoundTemplate"
                      placeholder="Destination"
                      formControlName="destination"
                      (keydown)="onKeyDownEvent($event)"
                      (inputChanged)="onSearch($event)"
                      (scrolledToEnd)="onScroll()"
                      [(ngModel)]="keywordAuto"
                    >
                    </ng-autocomplete>

                    <ng-template #itemTemplate let-item>
                      <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                  <div
                    *ngIf="
                      setDestinationsubmitted &&
                      !this.transportationDetailForm.controls['destination']?.value?.hasOwnProperty(
                        'name'
                      )
                    "
                    class="input-error destinatioErrorMessage"
                  >
                    Select city from list.
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="required" aria-required="true">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForLocation']?.value"
                      class="sub-header-drpdown pb-2"
                      >Transport mode</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="transportModeItems"
                      [searchable]="false"
                      formControlName="transportModeForLocation"
                      (change)="changeTransportMode($event)"
                      bindLabel="name"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Select transport mode"
                      *ngIf="!isCustomTruck"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control search-input search"
                            id="inputValidation"
                            placeholder="Search..."
                            (input)="select.filter($any($event.target).value)"
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="customTruckItems"
                      [searchable]="false"
                      formControlName="transportModeForLocation"
                      (change)="changeTransportMode($event)"
                      bindLabel="name"
                      [searchFn]="commonInputSearch"
                      placeholder="Select transport mode"
                      *ngIf="isCustomTruck"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control search-input search"
                            id="inputValidation"
                            (input)="select.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                    <div
                      *ngIf="
                        setDestinationsubmitted &&
                        !transportationDetailForm.controls['transportModeForLocation'].value
                      "
                      class="input-error"
                    >
                      Please select transport mode
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="isCheckUpdateDestination">
                  <div class="form-group required" aria-required="true">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                      class="placeholder-sub-header pb-2"
                      >Holder_text</label
                    >
                    <div class="services-form">
                      <input
                        (keydown)="noSpecialKeys($event)"
                        placeholder="Distance"
                        formControlName="distanceManulaLocation"
                      />
                      <label>Distance </label>
                    </div>
                    <div *ngIf="setDestinationsubmitted">
                      <div
                        *ngIf="
                          transportationDetailForm.controls['distanceManulaLocation'].value == 0
                        "
                        class="input-error"
                      >
                        The number of licenses must be greater than 0
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label
                    *ngIf="transportationDetailForm.controls['transportModeForLocation']?.value"
                    class="placeholder-sub-header pb-2"
                    >Holder_text</label
                  >
                  <div>
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="!isCheckUpdateDestination"
                      (click)="setDestination()"
                    >
                      Add transport leg
                    </button>
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="isCheckUpdateDestination"
                      (click)="setDestination()"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Distance -->
            <div class="fade show" *ngIf="selectDistance">
              <div class="row my-3">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input
                        type="checkbox"
                        class="chkOverview"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="isCustomTruck"
                        (change)="chnageCustomTruck($event)"
                      />
                    </div>
                    <div>
                      <span class="checkbox-style">Custom truck</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div
                    class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                  >
                    <div></div>
                    <div *ngIf="showCustomTruckAccess">
                      <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                        ><span class="redirectLinkText">Add custom truck</span></a
                      >
                      <a
                        class="setLinkIconPosition"
                        target="_blank"
                        replaceUrl="true"
                        routerLink="custom/customTrucks"
                      >
                        <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                      </a>
                      <span class="setLinkIconPosition" (click)="getCustomTruckList()"
                        ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngrxLet="
                  projectFacde.getTransportScenarioManualDistanceList$ as getTransportScenarioManualDistanceList
                "
              >
                <ng-container *ngIf="getTransportScenarioManualDistanceList?.length > 0">
                  <piqet-angular-portlet
                    [columnDefs]="distanceProcessColumnDef"
                    [frameworkComponents]="frameworkComponents"
                    [gridData]="getTransportScenarioManualDistanceList"
                    [hideSearch]="true"
                    [hidePagination]="true"
                    [isSetWidth]="true"
                    [gridName]="'Project eol pre retail distance'"
                  >
                  </piqet-angular-portlet>
                </ng-container>
              </div>
              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="form-group required" aria-required="true">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForDistance'].value"
                      class="sub-header-drpdown pb-2"
                      >Transport mode</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="transportModeItems"
                      *ngIf="!isCustomTruck"
                      [searchable]="false"
                      formControlName="transportModeForDistance"
                      (change)="changeTransportMode($event)"
                      bindLabel="name"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Transport mode"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control search-input search"
                            id="inputValidation"
                            (input)="select.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="customTruckItems"
                      [searchable]="false"
                      formControlName="transportModeForDistance"
                      (change)="changeTransportMode($event)"
                      bindLabel="name"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Transport mode"
                      *ngIf="isCustomTruck"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control search-input search"
                            id="inputValidation"
                            (input)="select.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                    <div
                      *ngIf="
                        setManualDistanceSubmitted &&
                        !transportationDetailForm.controls['transportModeForDistance'].value
                      "
                      class="input-error"
                    >
                      Please select transport mode
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="form-group required" aria-required="true">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForDistance'].value"
                      class="placeholder-sub-header pb-2"
                      >Holder_text</label
                    >
                    <div class="services-form">
                      <input
                        type="number"
                        maxlength="100"
                        placeholder="Component name"
                        formControlName="distance"
                        piqetAngularInputNumber
                        [preventNegative]="true"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      />
                      <label>Distance</label>
                    </div>
                    <div *ngIf="setManualDistanceSubmitted">
                      <div
                        *ngIf="transportationDetailForm.controls['distance'].value === 0"
                        class="input-error"
                      >
                        The number of licenses must be greater than 0
                      </div>
                    </div>
                    <div
                      *ngIf="
                        setManualDistanceSubmitted &&
                        !transportationDetailForm.controls['distance'].value &&
                        transportationDetailForm.controls['distance'].value !== 0
                      "
                      class="input-error"
                    >
                      Please select distance
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="add-button">
                    <button
                      class="modelBtn purple-button-leg"
                      *ngIf="!isCheckEditManudalDist"
                      (click)="addTransportDistance()"
                    >
                      Add transport leg
                    </button>
                    <button
                      class="modelBtn purple-button-leg"
                      *ngIf="isCheckEditManudalDist"
                      (click)="addTransportDistance()"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Custom -->
            <div class="fade show" *ngIf="selectCustom">
              <div class="row mt-3">
                <div>
                  <div class="col-12">
                    <div class="d-flex justify-content-end">
                      <div></div>
                      <div *ngIf="showCustomTransportAccess">
                        <a class="add-link" target="_blank" routerLink="custom/customTransport"
                          ><span class="redirectLinkText">Add custom transport scenario</span></a
                        >
                        <a
                          class="setLinkIconPosition"
                          target="_blank"
                          replaceUrl="true"
                          routerLink="custom/customTransport"
                        >
                          <img
                            src="./assets/icons/redirect-icon.svg"
                            alt=""
                            width="15"
                            height="13"
                          />
                        </a>
                        <span class="setLinkIconPosition" (click)="getCustomTransport()"
                          ><img
                            src="./assets/icons/refresh-circle.svg"
                            alt=""
                            width="14"
                            height="13"
                        /></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div class="form-group required">
                    <label
                      *ngIf="transportationDetailForm.controls['customScenarioItem'].value"
                      class="sub-header-drpdown pb-2"
                      >Selected custom freight scenario</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="customtransportScenarioItems"
                      [searchable]="false"
                      formControlName="customScenarioItem"
                      bindLabel="name"
                      (change)="changeCustomTransportItem($event)"
                      (clear)="resetTransport()"
                      [searchFn]="commonInputSearchForCountry"
                      placeholder="Select custom freight mode"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            class="search"
                            type="text"
                            class="form-control search-input"
                            id="inputValidation"
                            (input)="select.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="add-button text-margin">
                    <button class="modelBtn purple-button-leg" (click)="addCustomFreight()">
                      Add transport leg
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngrxLet="projectFacde.freightProcessData$ as freightProcessData">
              <div *ngIf="freightProcessData?.length > 0 && !selectLocation && !selectDistance">
                <piqet-angular-portlet
                  [columnDefs]="customTransportDef"
                  [isSetWidth]="true"
                  [gridData]="freightProcessData"
                  [hideSearch]="true"
                  [hidePagination]="true"
                  [gridName]="'product ingredient custom transport'"
                >
                </piqet-angular-portlet>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-2" />

        <div formGroupName="energyProcessDetailForm">
          <div class="row my-2">
            <div class="col-12">
              <label class="subTitleName">Reuse process</label>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 customTruckCheckBox">
              <div class="d-flex checkBoxAlienMent">
                <div>
                  <input
                    type="checkbox"
                    class="chkOverview"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="isCustomReuse"
                    (change)="chnageCustomReuse($event)"
                  />
                </div>
                <div>
                  <span class="checkbox-style">Custom reuse</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <div
                class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
              >
                <div></div>
                <div *ngIf="showCustomReuse">
                  <a class="add-link" target="_blank" routerLink="custom/customReuse"
                    ><span class="redirectLinkText">Add custom reuse</span></a
                  >
                  <a
                    class="setLinkIconPosition"
                    target="_blank"
                    replaceUrl="true"
                    routerLink="custom/customReuse"
                  >
                    <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                  </a>
                  <span class="setLinkIconPosition" (click)="getCustomReuseList()"
                    ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                  /></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-2">
            <div [ngClass]="isCustomReuse ? 'col-md-12' : 'col-md-6'">
              <div class="form-group" aria-required="true">
                <label class="sub-header-drpdown">Reuse energy process</label>
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #process
                  [items]="energyFillinListiItems"
                  [searchable]="false"
                  formControlName="reuseName"
                  bindLabel="name"
                  [searchFn]="commonInputSearchForCountry"
                  placeholder="Reuse energy process "
                  *ngIf="!isCustomReuse"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control search-input search"
                        id="inputValidation"
                        (input)="process.filter($any($event.target).value)"
                        placeHolder="search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #process
                  [items]="customReuseItems"
                  [searchable]="false"
                  formControlName="reuseName"
                  bindLabel="description"
                  [searchFn]="commonInputSearch"
                  placeholder="Reuse energy process "
                  *ngIf="isCustomReuse"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="form-control search-input search"
                        id="inputValidation"
                        (input)="process.filter($any($event.target).value)"
                        placeholder="search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                      {{ item.description }}
                    </div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="isReusesubmitted && !energyProcessDetailForm.controls['reuseName'].value"
                  class="input-error"
                >
                  Please select energy process
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="!isCustomReuse">
              <piqet-angular-common-input
                formControlName="reuseAmount"
                [control]="energyProcessDetailForm.get('reuseAmount')"
                label="Amount (per reuse cycle)"
                [name]="'reuseAmount'"
                placeholder="Amount (per reuse cycle)"
                [maxLength]="100"
                [preventNegative]="true"
                inputType="number"
                (customBlur)="getCostPerPackage()"
                [submitted]="false"
              >
              </piqet-angular-common-input>
            </div>
          </div>
          <div class="row" *ngIf="isCostTrunOff && !isCustomReuse">
            <div class="col-md-6">
              <div class="form-group" aria-required="true">
                <piqet-angular-common-input
                  formControlName="cost"
                  [control]="energyProcessDetailForm.get('cost')"
                  label="Cost per unit"
                  [name]="'cost'"
                  placeholder="Cost per unit"
                  [maxLength]="10"
                  [preventNegative]="true"
                  inputType="number"
                  (customBlur)="getCostPerPackage()"
                  [submitted]="false"
                >
                </piqet-angular-common-input>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" aria-required="true">
                <piqet-angular-common-input
                  formControlName="costPackage"
                  [control]="energyProcessDetailForm.get('costPackage')"
                  label="Cost per package (USD)"
                  [name]="'costPackage'"
                  placeholder="Cost per package (USD)"
                  [maxLength]="10"
                  [preventNegative]="true"
                  inputType="number"
                  [submitted]="false"
                >
                </piqet-angular-common-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <div class="add-button">
              <button
                class="modelBtn"
                [ngClass]="{ addLightGray: !isRowEditable }"
                [disabled]="isRowEditable"
                (click)="addRuseData()"
              >
                Add
              </button>
            </div>
          </div>
        </div>
        <ng-container
          *ngrxLet="projectFacde.getPreRetailReuseActionList$ as getPreRetailReuseActionList"
        >
          <div
            id="divmanufactureofmaterialList"
            *ngIf="getPreRetailReuseActionList.length > 0"
            class="row grid-div"
          >
            <piqet-angular-portlet
              [columnDefs]="reuseColumnDef"
              [frameworkComponents]="frameworkComponentsForPreRetailTransport"
              [gridData]="getPreRetailReuseActionList"
              [gridName]="'EOL add reuse'"
              [hidePagination]="true"
              [hideSearch]="true"
              [class]="'p-0 overflowCheck'"
              [inlineEdit]="true"
              [isInlineGrid]="true"
            >
            </piqet-angular-portlet>
          </div>
        </ng-container>
        <div
          class="row"
          *ngrxLet="{
            locationProcessData: (projectFacde.getTransportScenarioManudalLocationList$ | async),
            distanceProcessData: (projectFacde.getTransportScenarioManualDistanceList$ | async),
            freightProcessData: (projectFacde.freightProcessData$ | async),
            getPreRetailReuseActionList: (projectFacde.getPreRetailReuseActionList$ | async)
          } as addTransportData"
        >
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 input-div">
            <div class="commonBtnMarginForGrid">
              <button
                (click)="
                  addComponentTransport(
                    addTransportData.locationProcessData,
                    addTransportData.distanceProcessData,
                    addTransportData.freightProcessData,
                    addTransportData.getPreRetailReuseActionList
                  )
                "
                class="modelBtn purpleBtnHoverEffect purple-button"
              >
                {{ isComponentDetailEdit ? 'Update reuse' : 'Add reuse' }}
              </button>
            </div>
          </div>
          <ng-container
            *ngrxLet="projectFacde.getComponentPreRetailList$ as getComponentPreRetailList"
          >
            <div *ngIf="submitted && getComponentPreRetailList.length <= 0" class="input-error">
              {{ eolValidationMessages }}
            </div>
          </ng-container>
        </div>
        <div
          class="input-error"
          *ngrxLet="{
            duplicateComponentErr: (projectFacde.errMessage$ | async),
            gridErr: (projectFacde.errMsgReuseEOL$ | async)
          } as errMessage"
        >
          {{ errMessage?.duplicateComponentErr || errMessage?.gridErr }}
        </div>
        <div id="divmanufactureofmaterialList" class="grid-div">
          <ng-container
            *ngrxLet="projectFacde.getComponentPreRetailList$ as getComponentPreRetailList"
          >
            <piqet-angular-portlet
              [columnDefs]="
                getEolPreRetailData.isCostTrunOff
                  ? ingredientTransportColumnDef
                  : columnDefsPreretailCost
              "
              [frameworkComponents]="frameworkComponentsForPreRetailTransport"
              [gridData]="getComponentPreRetailList"
              [class]="'overflowCheck dropdownOverFLow'"
              [gridName]="'product ingredient custom transport column list'"
              [hidePagination]="true"
              [hideSearch]="true"
            >
            </piqet-angular-portlet>
          </ng-container>
        </div>
      </form>
      <div
        class="setButtonAndError"
        *ngrxLet="{
          getComponentPreRetailList: (projectFacde.getComponentPreRetailList$ | async)
        } as preRetailaData"
      >
        <div class="modal-footer">
          <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
          <button
            type="button"
            class="actionBTN modelBtn purpleBtnHoverEffect"
            *ngIf="showEdit"
            (click)="saveData(preRetailaData.getComponentPreRetailList)"
          >
            Save
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="
            submitted ||
            (componentSubmitted &&
              (showTripErr || showReuseErr) &&
              (reuseProcessDetailForm.controls['componentName']?.invalid || !checkHitButton))
          "
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div style="margin-left: 10px">
              <div class="mb-3">
                <span class="alert-error">To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (componentSubmitted || submitted) &&
                    reuseProcessDetailForm.controls['componentName']?.invalid
                  "
                  class="alert-error"
                >
                  Component
                </div>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (componentSubmitted || submitted) &&
                    reuseProcessDetailForm.controls['reuseType']?.invalid
                  "
                  class="alert-error"
                >
                  Type
                </div>
              </div>
              <ng-container *ngTemplateOutlet="eolErrors"> </ng-container>
              <div class="topBottomCss">
                <ng-container
                  *ngrxLet="projectFacde.getComponentPreRetailList$ as getComponentPreRetailList"
                >
                  <div
                    *ngIf="submitted && getComponentPreRetailList.length <= 0"
                    class="alert-error"
                  >
                    {{ eolValidationMessages }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #eolErrors>
  <div class="topBottomCss">
    <div *ngIf="showTripErr" class="alert-error">
      {{ noOfTripsErr }}
    </div>
  </div>
  <div class="topBottomCss">
    <div *ngIf="showReuseErr" class="alert-error">
      {{ percentReuseEOLerr }}
    </div>
  </div>
</ng-template>
